// errors — mapa KODU BŁĘDU z API na zdanie dla użytkownika.
// Klucze to dosłowne kody, które zwraca backend (`{"error": "<klucz>"}`), a nie
// nazwy wymyślone na froncie. Dzięki temu nowy kod po stronie serwera od razu
// widać jako brakujące tłumaczenie, zamiast wyświetlać surowy kod klientowi.
// Klucze lustrzane z ../en/errors.ts.
//
// `consent_required` NIE MA tu własnego zdania celowo — komunikat żyje przy
// polu, którego dotyczy (`checkout.consent.required`). Dwie kopie tego samego
// zdania w dwóch miejscach rozjadą się przy pierwszej korekcie.
export const errors = {
  // Płatności / plan (P01).
  //
  // Te kody przychodzą INACZEJ niż wszystkie pozostałe w tym pliku: nie z `api()`, tylko
  // z PRZEKIEROWANIA. `/billing/checkout`, `/billing/topup` i `/billing/portal` są
  // POST-owane przez prawdziwy <form> (ścieżka sukcesu robi 303 na Stripe, czyli na inny
  // origin — `fetch` za tym nie pójdzie), więc do 2026-08-31 błąd nie trafiał na żaden
  // ekran: `jsonify(...)` był RENDEROWANY JAKO STRONA i podmieniał aplikację na surowy
  // JSON po angielsku. Teraz serwer robi 303 z `?err=<kod>`, a ekran czyta go tą samą
  // funkcją `describeApiError` co każdą inną odmowę — stąd zdania tutaj.
  //
  // Żadne z nich nie obiecuje „spróbuj ponownie", bo w żadnym z tych stanów ponowienie
  // nie zmienia wyniku. Wyjątkiem jest `csrf_invalid`, gdzie zmienia — i tam jest napisane.
  country_not_supported: 'Na razie nie obsługujemy płatności w tym kraju.',
  capacity_cap: 'Ten pakiet wystarczyłby na ponad pół roku publikacji przy Twojej liczbie kont. Dokup najpierw slot.',
  plan_unknown: 'Nie znamy takiego planu - link mógł się zdezaktualizować. Wybierz plan z cennika.',
  plan_not_purchasable: 'Tego planu nie da się teraz kupić i jest to po naszej stronie, nie po Twojej. Nic nie zostało pobrane - napisz do nas, a powiemy, kiedy wróci.',
  billing_unavailable: 'Płatności są chwilowo wyłączone po naszej stronie. Nic nie zostało pobrane; spróbuj później albo napisz do nas.',
  invoice_document_unavailable: 'Nie udało się teraz otworzyć PDF. Spróbuj ponownie za chwilę.',
  invoice_document_not_found: 'Ta płatność nie ma dostępnego dokumentu PDF.',
  bundle_invalid: 'Nie rozpoznajemy tego pakietu tokenów. Wybierz pakiet z listy.',
  gem_pack_unknown: 'Taki pakiet tokenów nie istnieje. Wybierz pakiet z listy.',
  gem_pack_not_for_plan: 'Ten pakiet jest dostępny dopiero w wyższym planie. Zmień plan albo wybierz mniejszy pakiet.',
  no_subscription: 'Nie mamy aktywnej subskrypcji, którą można by tu zarządzać. Jeśli płatność właśnie przeszła, odśwież stronę za chwilę.',
  csrf_invalid: 'Sesja wygasła, zanim przyjęliśmy płatność. Nic nie zostało pobrane - zaloguj się i spróbuj jeszcze raz.',
  // Publikowanie (P02, ekran Kont). Kody wyliczone z `app/publishing/routes.py`, a nie
  // wymyślone: `Accounts.tsx` woła /connections, /connect, /connections/<id>/disconnect,
  // /reauth i /creator-info, i to jest komplet tego, co te pięć endpointów zwraca.
  // `slot_limit_reached` już tu było (linia niżej); te pięć spadało na `errors.unknown`
  // — „coś po naszej stronie, spróbuj za chwilę" — a dla trzech z nich to nieprawda:
  // nie jest po naszej stronie i ponowienie nie pomoże.
  // Kody z `/publish` (content_rejected, invalid_scheduled_at, connection_not_found)
  // świadomie NIE tutaj: to ścieżka kampanii, nie ten ekran.
  publishing_unavailable: 'Publikowanie jest chwilowo niedostępne - to po naszej stronie, nie po Twojej. Spróbuj za kilka minut; nic nie przepadło.',
  invalid_slot_index: 'Ten slot nie istnieje. Odśwież stronę i spróbuj jeszcze raz.',
  not_found: 'Nie znaleźliśmy tego konta - mogło zostać odłączone w innej karcie. Odśwież stronę.',
  creator_info_unavailable: 'TikTok nie odpowiedział na pytanie o limity tego konta. Spróbuj za chwilę - samo podłączenie jest w porządku.',
  creator_info_unsupported: 'To konto nie udostępnia informacji o limitach publikacji. Reszta działa normalnie.',
  slot_limit_reached: 'Wykorzystałeś wszystkie sloty - dokup slot albo odłącz konto.',
  insufficient_gems: 'Za mało tokenów. Dokup pakiet albo poczekaj na odnowienie planu.',
  // Render (P00/P03): upload dłuższy niż limit editu nie jest odrzucany —
  // przycinamy. Ten błąd widać tylko, gdy ktoś jawnie zażąda dłuższego editu.
  duration_too_long: 'Edit może trwać najwyżej 30 sekund. Przytnij utwór i spróbuj ponownie.',
  // Ostatnia deska ratunku: kod, którego front jeszcze nie zna. Nigdy nie
  // pokazujemy surowego kodu ani „Error 500”.
  unknown: 'Coś poszło nie tak po naszej stronie. Spróbuj ponownie za chwilę - jeśli to się powtórzy, napisz do nas.',
  // ── KONFLIKTY 409 ─────────────────────────────────────────────────────────
  // `describeApiError` czyta odmowę z 403 ORAZ 409, i to jest decyzja o treści, nie
  // o kodzie: wszystkie dziesięć kodów 409 tego backendu opisuje STAN, którego
  // ponowienie nie zmienia. „Spróbuj ponownie za chwilę" przy kampanii, która jest
  // już opublikowana, to zaproszenie do klikania w ścianę — i przypisanie nam winy
  // za sytuację, która nie jest awarią.
  //
  // Bez zdania TUTAJ każdy z nich schodziłby do `unknown`, czyli „coś poszło nie tak
  // po naszej stronie" — nieprawda przy każdym z dziesięciu.
  //
  // `gems_on_hold` ma OSOBNE zdanie w `appCampaigns.apiError` (pasek kampanii czyta
  // własną przestrzeń przez strażnikowane `t()`). To tutaj jest dla powierzchni
  // ogólnych; kopia jest świadoma i krótsza, bo tam jest miejsce na kontekst, a tu nie.
  // Ma bliźniaka w `appCampaigns.apiError.already_published` — dłuższa wersja dla dwóch
  // przycisków kampanii (Ponów / Usuń z planu), bo tam jest miejsce na kontekst, a tu nie.
  // Poprawiając to zdanie, popraw tamto.
  already_published: 'To już zostało opublikowane.',
  campaign_cancelled: 'Ta kampania jest anulowana.',
  campaign_not_editable: 'Tej kampanii nie da się już edytować - jest w trakcie albo zakończona.',
  campaign_not_pausable: 'Tej kampanii nie da się teraz wstrzymać.',
  campaign_not_paused: 'Ta kampania nie jest wstrzymana.',
  gems_on_hold: 'Tokeny na tę kampanię są zarezerwowane do czasu jej zakończenia lub anulowania.',
  no_audio: 'Ten utwór nie ma ścieżki dźwiękowej.',
  nothing_delivered: 'Nie ma czego pobrać - nic się jeszcze nie wyrenderowało.',
  pack_unavailable: 'Ta paczka klipów jest niedostępna.',
  // Jedyny z dziesięciu, przy którym ponowienie KIEDYŚ zadziała — ale nie teraz,
  // i zdanie mówi dlaczego, zamiast obiecywać „spróbuj ponownie".
  render_in_flight: 'Ten render już się liczy. Poczekaj, aż się skończy.',
  // Ta sama prawda o analizie utworu: serwer odmawia ponowienia, dopóki cokolwiek
  // się liczy (`app/assets/service.py#retry_transcription`), i NIC nie pobiera — więc
  // ekran nie ma prawa powiedzieć tu ani słowa o pieniądzach (przegląd D, M-3).
  analysis_in_progress: 'Ta analiza już się liczy. Poczekaj, aż się skończy.',
  // Druga połowa tego samego 409: serwer odmawia, bo NIE MA czego ponawiać (gotowy
  // tekst, którego cennik nie wycenia, i policzony rytm). Do 2026-09-21 obie odmowy
  // dostawały zdanie o trwającej analizie — obietnicę końca czegoś, co nie biegło
  // (przegląd E, N5-M1-EDITOR-NOT-GATED). Ponowienie tego nie zmieni, i zdanie to mówi.
  not_retryable: 'Nie ma czego ponawiać: ta analiza jest już policzona.',
  // `app/assets/service.py#delete_music` odmawia, dopóki utwór wisi w serii, która się
  // liczy. To nie awaria: ta sama próba po zakończeniu serii przejdzie, i zdanie to mówi.
  track_in_use: 'Ten utwór jest w trwającej serii. Usuniesz go, gdy seria się skończy.',
  // Odmowy 403 z kodem. Bez zdania tutaj `describeApiError` schodzi do `unknown`,
  // czyli mówi „to nasza wina, spróbuj ponownie” o rzeczach, które nie są ani naszą
  // winą, ani ponawialne. Trzy z tych czterech nie miały zdania do 2026-08-30.
  email_unverified: 'Zanim się zalogujesz, potwierdź adres e-mail - wysłaliśmy go przy zakładaniu konta. Zajrzyj też do spamu.',
  account_suspended: 'Twoje konto jest zawieszone. Napisz do nas, a sprawdzimy, co się stało.',
  account_pending: 'Twoje konto czeka na zatwierdzenie. Odezwiemy się, gdy będzie gotowe.',
  autopilot_disabled: 'Autopilot jest wyłączony na tym koncie.',
  // Nieudany render. NIE jest to odmowa (`describeApiError` tego nie czyta) — to zdanie
  // dla ekranu edita, który dziś drukował surowy techniczny string serwera po angielsku
  // na polskiej stronie. Druga połowa („nie pobieramy gemów") jest twierdzeniem
  // o inwariancie #5, nie o tym wierszu: zwrot robi `refund:render:<id>` w portfelu,
  // a payload statusu nie niesie flagi zwrotu (patrz komentarz przy `refunded_*`).
  render_failed: 'Ten render się nie udał. Nie pobieramy za niego tokenów.',

  // Etykiety przycisków przy odmowach. Rodzina istnieje dla mechanizmu; dziś ma JEDEN
  // wpis, bo tylko jedna odmowa ma dokąd prowadzić (patrz tabela CTA w ds/feedback/apiError.ts).
  cta: {
    account_suspended: 'Napisz do nas',
  },
}
